// removed by extract-text-webpack-plugin
module.exports = {"stepPanel":"DissertationInfo__stepPanel___1KLK3 stepPanel__stepPanel___1Vrm5 layout__panel___vsQZV","row":"DissertationInfo__row___3WXjE","rowRight":"DissertationInfo__rowRight___34nen DissertationInfo__row___3WXjE","language":"DissertationInfo__language___1YYSA","institutionName":"DissertationInfo__institutionName___3iFLJ","manuscriptCompletionYear":"DissertationInfo__manuscriptCompletionYear___1A_g-","delayReleaseDate":"DissertationInfo__delayReleaseDate___1McNL","addAnotherMemberButton":"DissertationInfo__addAnotherMemberButton___3qKEL","licenseType":"DissertationInfo__licenseType___Q9SsW"};


//////////////////
// WEBPACK FOOTER
// ./src/dissertation-info/components/DissertationInfo.css
// module id = 748
// module chunks = 0